import { InfoOutlineIcon, WarningTwoIcon } from '@chakra-ui/icons'
import { Box, Flex, IconButton, Img, Text } from '@chakra-ui/react'
import { ProfilePicturePopover } from '@components/Admins/ProfilePicturePopover'
import { useApp } from '@hb/react'
import { colors, getDateString } from '@hb/shared'
import { useMemo } from 'react'
import { useProfile } from '../../../../../../contexts/user/ProfileContext'
import { useProfileLayout } from '../../../../../../contexts/user/ProfileLayoutContext'
import pinIcon from '../../../../../../icons/pin.svg'

export const PatientHeaderBar = () => {
  const { user, userId } = useProfile()
  const { appName } = useApp()
  const { sidebar } = useProfileLayout()
  const { fname, lname, middleName, dob, adminAlerts, practiceAlerts } = user ?? {}
  const name = useMemo(
    () =>
      `${fname || '[Missing first name]'}${middleName ? ` ${middleName}` : ''} ${lname || '[Missing Last Name]'}`,
    [fname, lname, middleName],
  )
  const numAlerts = useMemo(() => {
    const numPracticeAlerts = Object.keys(practiceAlerts ?? {}).length
    if (appName === 'providers-app') return numPracticeAlerts
    return numPracticeAlerts + Object.keys(adminAlerts ?? {}).length
  }, [adminAlerts, practiceAlerts, appName])
  return (
    <Flex
      align="center"
      gap={2}
      pl={2}
      // leave room for the modal close button in the top right corner
      pr="44px"
      minH="36px"
      flexShrink={0}
      cursor="pointer"
      onClick={sidebar.onOpen}
      bg={`${colors.pink.hex}77`}
      borderBottom="1px solid #cdcdcd">
      <Box onClick={e => e.stopPropagation()}>
        <ProfilePicturePopover gutter={8} userId={userId} size={7} noOnlineIndicator />
      </Box>
      <Flex flex={1} minW={0} align="baseline" gap={2}>
        <Text
          isTruncated
          fontSize="sm"
          fontFamily="Hero-New"
          lineHeight={1}
          fontWeight={500}
          color="gray.700">
          {name || 'No name entered'}
        </Text>
        <Text
          fontSize="xs"
          lineHeight={1}
          fontWeight={500}
          color="gray.600"
          whiteSpace="nowrap"
          flexShrink={0}>
          DOB: {dob ? getDateString(dob, 'short') : 'None'}
        </Text>
      </Flex>
      {numAlerts ? (
        <Flex align="center" gap={1} bg="red.500" borderRadius="full" px={2} py={0.5}>
          <WarningTwoIcon color="white" w={3} h={3} />
          <Text color="white" fontSize="xs" fontWeight={600} lineHeight={1}>
            {numAlerts}
          </Text>
        </Flex>
      ) : null}
      {sidebar.canPin ? (
        <IconButton
          aria-label="Pin patient panel open"
          size="xs"
          variant="ghost"
          _hover={{ bg: 'blackAlpha.100' }}
          icon={<Img src={pinIcon} h="14px" opacity={0.7} />}
          onClick={e => {
            e.stopPropagation()
            sidebar.setPinned(true)
          }}
        />
      ) : null}
      <IconButton
        aria-label="Show patient details"
        size="xs"
        variant="ghost"
        _hover={{ bg: 'blackAlpha.100' }}
        icon={<InfoOutlineIcon color="gray.600" />}
        onClick={sidebar.onOpen}
      />
    </Flex>
  )
}
